import React from 'react'
import DoubleLoader from './DoubleLoader';
import LoaderShadow from './LoaderShadow';

const DrawerLoader = () => {
    const renderLoader=()=>{
     
        return <div className='row drawer'>
            {<DoubleLoader/>}

            {<LoaderShadow/>}
            {<LoaderShadow/>}
            {<LoaderShadow/>} 



            </div>;
        }
  return (
    <div>
              {renderLoader()}

    </div>
  )
}

export default DrawerLoader
